module.exports = __webpack_public_path__ + "static/media/Informativa N.e2f770d2.svg";